/**
 * 地図クリック（青ピン）用の備考同期システム
 * PropertySelectionGridと地図クリックポップアップ間で備考データを同期するためのユーティリティ
 */

import { createPropertyGridPopupSyncSystem } from "./createSyncSystem";

export const MAP_CLICK_REMARKS_UPDATE_EVENT = "updateMapClickRemarks";

const { dispatch, addListener } = createPropertyGridPopupSyncSystem<string>(
  MAP_CLICK_REMARKS_UPDATE_EVENT
);

/**
 * 地図クリックの備考更新イベントを発火する
 * @param remarks 更新する備考
 */
export const dispatchMapClickRemarksUpdate = (remarks: string): void => {
  dispatch(remarks);
};

/**
 * 地図クリックの備考更新イベントリスナーを追加する
 * @param callback 備考が更新された際に呼び出されるコールバック関数
 * @returns クリーンアップ関数
 */
export const addMapClickRemarksUpdateListener = (
  callback: (remarks: string) => void
): (() => void) => {
  return addListener(callback);
};
